//Sion order sizes on product pages from smallest to largest (this includes all types of sizes and shrinks longer sizes on product cards)
document.addEventListener('DOMContentLoaded', function () {

  // ---- Size ranking logic --------------------------------------------
  // Handles: letter sizes (XXS-4XL), letter+measurement ("L 59-63cm"),
  // pure measurements ("34mm", "48x58mm"), UK/US/EU shoe sizes,
  // ranges/combos ("S/M/L", "M-XXL"), one-size ("OS"/"One Size").
  // Anything unrecognised falls to the end, in original order.

  const LETTER_SIZE_ORDER = {
    'xxs': 0, '2xs': 0,
    'xs': 1,
    's': 2, 'small': 2,
    'm': 3, 'medium': 3,
    'l': 4, 'large': 4,
    'xl': 5,
    'xxl': 6, '2xl': 6,
    'xxxl': 7, '3xl': 7,
    '4xl': 8, 'xxxxl': 8
  };

  const ONE_SIZE_TOKENS = new Set(['os', 'one size', 'onesize', 'o/s']);

  // Leading letter code followed by a word boundary,
  // e.g. "l" in "l 59-63cm", "xl" in "xl 61-62cm", "s" in "s/m/l"
  const LEADING_CODE_RE = /^(xxxl|xxxxl|xxl|xxs|2xs|3xl|4xl|2xl|xl|xs|s|m|l)\b/;

  function getSizeRank(value) {
    if (value == null) return 9999;
    const s = value.trim().toLowerCase().replace(/\s+/g, ' ');
    if (!s) return 9999;

    if (LETTER_SIZE_ORDER.hasOwnProperty(s)) return LETTER_SIZE_ORDER[s];
    if (ONE_SIZE_TOKENS.has(s)) return 100;

    const leadMatch = s.match(LEADING_CODE_RE);
    if (leadMatch && LETTER_SIZE_ORDER.hasOwnProperty(leadMatch[1])) {
      return LETTER_SIZE_ORDER[leadMatch[1]];
    }

    // Numeric fallback (UK sizes, mm/cm measurements, "US8.5/UK8/EU42" etc.)
    // Uses the first number found in the string.
    const numMatch = s.match(/(\d+(\.\d+)?)/);
    if (numMatch) return 200 + parseFloat(numMatch[1]);

    return 9999; // unrecognised — pushed to the end
  }

  // ---- DOM sorting (unchanged structure from the working version) ----

  // Extracts a UK size from combined strings, e.g. "US8/UK7.5/EU41.5" -> "UK 7.5"
  const UK_SIZE_RE = /uk\s?(\d+(\.\d+)?)/i;

  // Extracts the first value from slash-delimited spec strings,
  // e.g. "23/9°/800mm" -> "23". Only triggers when the string has
  // multiple "/"-separated parts and the LAST part is purely a mm value,
  // so single dimension specs like "48x58mm" are left untouched.
  function extractLeadingSpecValue(text) {
    const parts = text.split('/');
    if (parts.length < 2) return null;
    const last = parts[parts.length - 1].trim();
    return /^\d+(\.\d+)?mm$/i.test(last) ? parts[0].trim() : null;
  }

  // Shortens a display label to just its leading size code where one exists
  // e.g. "S 51-55cm" -> "S", "XL 61-62cm" -> "XL".
  // Also extracts just the UK figure from combined shoe-size strings,
  // e.g. "US8/UK7.5/EU41.5" -> "UK 7.5", and the leading value from
  // slash-delimited specs, e.g. "23/9°/800mm" -> "23".
  // Leaves anything else untouched (single mm/cm dimensions, "One Size" etc.)
  function shortenSizeLabel(text) {
    const trimmed = text.trim();

    const specMatch = extractLeadingSpecValue(trimmed);
    if (specMatch) return specMatch;

    const ukMatch = trimmed.match(UK_SIZE_RE);
    if (ukMatch) return 'UK ' + ukMatch[1];

    const match = trimmed.toLowerCase().match(LEADING_CODE_RE);
    return match ? trimmed.slice(0, match[1].length) : trimmed;
  }

  // Product page: input + label pairs inside .option-selector__btns
  function sortProductPage() {
    document.querySelectorAll('.option-selector__btns').forEach(function (container) {
      const inputs = Array.from(container.querySelectorAll('input.opt-btn'));
      if (!inputs.length) return;

      // Only touch Size selectors — identified by the input name/id
      // containing "size-selector" (matches this theme's naming convention),
      // so Colour/Style selectors using the same markup are left alone.
      const isSizeSelector = inputs.some(function (input) {
        return /size-selector/i.test(input.name) || /size-selector/i.test(input.id);
      });
      if (!isSizeSelector) return;
      const pairs = inputs.map(function (input) {
        const label = container.querySelector('label[for="' + input.id + '"]');
        return { input, label, value: input.value };
      });

      pairs.sort(function (a, b) {
        return getSizeRank(a.value) - getSizeRank(b.value);
      });

      observer.disconnect();
      pairs.forEach(function (pair) {
        container.appendChild(pair.input);
        container.appendChild(pair.label);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  // Collection page: simple span elements inside .product-block-options__inner
  function sortCollectionPage() {
    document.querySelectorAll('.product-block-options[data-option-name="Size"]').forEach(function (wrapper) {
      const container = wrapper.querySelector('.product-block-options__inner');
      if (!container) return;

      const items = Array.from(container.querySelectorAll('.product-block-options__item'));
      if (!items.length) return;

      if (items.length >= 2) {
        items.sort(function (a, b) {
          return getSizeRank(a.dataset.optionItem) - getSizeRank(b.dataset.optionItem);
        });
      }

      observer.disconnect();
      items.forEach(function (item) {
        container.appendChild(item);
        const textEl = item.querySelector('.product-block-options__item__text');
        if (textEl) {
          textEl.textContent = shortenSizeLabel(item.dataset.optionItem);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  function sortAll() {
    sortProductPage();
    sortCollectionPage();
  }

  const observer = new MutationObserver(function (mutations) {
    const relevant = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && (
          node.matches('.option-selector__btns, .product-block-options') ||
          node.querySelector('.option-selector__btns, .product-block-options')
        );
      });
    });

    if (relevant) {
      sortAll();
    }
  });

  sortAll();
  observer.observe(document.body, { childList: true, subtree: true });

});











//Sion add sizes to product cards on collection page
(function () {
  function filterSizesForColour(cardEl, colour) {
    var sizeRow = cardEl.querySelector('.product-block-options--size');
    if (!sizeRow || !colour) return;

    var items = sizeRow.querySelectorAll('.product-block-options__item');

    var hasColourData = false;
    items.forEach(function (item) {
      if (item.hasAttribute('data-available-colours')) hasColourData = true;
    });
    if (!hasColourData) return;

    items.forEach(function (item) {
      var availableColours = (item.getAttribute('data-available-colours') || '').split('||');
      var isAvailable = availableColours.indexOf(colour) !== -1;
      item.classList.toggle('product-block-options__item--unavailable-for-colour', !isAvailable);
    });
  }

  function handlePriceUpdate(e) {
    var variant = e.detail.variant;
    var el = e.detail.el;
    if (!variant || !el) return;

    var colour = variant.option1 || variant.option2 || variant.option3;
    var cardEl = el.closest('product-block') || el;
    filterSizesForColour(cardEl, colour);
  }

  function attachListeners() {
    document.addEventListener('sezerium:price:update', handlePriceUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }
})();




















//Sion auto merchandising collections by ordering them by biggest size run
const sizeRunIndex = new Map();
const knownVariantIds = new Set();   // cards we've already registered/observed
const lockedVariantIds = new Set();  // cards frozen in place — about to be/already seen
const normaliseId = (id) => String(id).replace(/\D/g, '');

// Cards lock the moment they come within 800px of the viewport —
// i.e. shortly before a user would actually scroll to them, not the instant they render.
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const variantId = entry.target.dataset.sezeriumVariant;
      if (!variantId) return;
      lockedVariantIds.add(normaliseId(variantId));
      observer.unobserve(entry.target);
    });
  },
  { rootMargin: '0px 0px 800px 0px' }
);

document.addEventListener('sezerium:js:unload', (event) => {
  const { collectionEl, proceedProducts } = event.detail;

  if (Array.isArray(proceedProducts)) {
    proceedProducts.forEach((entry) => {
      if (!entry || !entry.product || !entry.variant) return;
      const { product, variant } = entry;
      if (!Array.isArray(product.options)) return;

      const sizeIndex = product.options.findIndex(
        (name) => typeof name === 'string' && name.toLowerCase() === 'size'
      );

      let count;
      if (sizeIndex === -1) {
        count = 1;
      } else {
        const raw = variant[`options${sizeIndex + 1}`];
        count = typeof raw === 'string' && raw.trim() !== ''
          ? raw.split(',').map((s) => s.trim()).filter(Boolean).length
          : 0;
      }

      sizeRunIndex.set(normaliseId(variant.id), count);
    });
  }

  const grid = document.querySelector('.sezerium-collection') || collectionEl;
  const allCards = Array.from(grid.querySelectorAll('product-block'));

  // Register any brand-new cards with the observer so they'll auto-lock
  // once they're about to be scrolled into view.
  allCards.forEach((card) => {
    const id = normaliseId(card.dataset.sezeriumVariant);
    if (!id || knownVariantIds.has(id)) return;
    knownVariantIds.add(id);
    observer.observe(card);
  });

  // Locked cards (already seen or about to be) never move again.
  // Pool cards (not yet near the viewport) are fully re-sortable every firing.
  const pool = allCards.filter(
    (c) => !lockedVariantIds.has(normaliseId(c.dataset.sezeriumVariant))
  );

  if (pool.length === 0) return;

  const sortedPool = pool.slice().sort((a, b) => {
    const aCount = sizeRunIndex.get(normaliseId(a.dataset.sezeriumVariant)) ?? 0;
    const bCount = sizeRunIndex.get(normaliseId(b.dataset.sezeriumVariant)) ?? 0;
    return bCount - aCount;
  });

  // Re-append the pool in sorted order — this naturally places it after
  // whatever's locked, since locked cards are never touched/moved.
  sortedPool.forEach((card) => grid.appendChild(card));
});

/* ---- main-dev: mega menu column packing ----
   Groups mega-menu columns so they fill the tallest column's height,
   avoiding a ragged bottom edge. Idempotent via data-packed guard. */
function packMegaMenuColumns() {
  var containers = document.querySelectorAll('.mega-menu__columns');
  containers.forEach(function(container) {
    if (container.dataset.packed) return;
    var columns = [].slice.call(container.children);
    if (!columns.length || columns[0].classList.contains('mega-menu__column-group')) return;

    var maxHeight = 0;
    columns.forEach(function(c) {
      if (c.offsetHeight > maxHeight) maxHeight = c.offsetHeight;
    });

    var groupHeight = function(group) {
      var h = 0;
      group.forEach(function(col) { h += col.offsetHeight; });
      return h;
    };

    var groups = [];
    columns.forEach(function(col) { groups.push([col]); });

    var changed = true;
    while (changed) {
      changed = false;
      for (var i = 0; i < groups.length - 1; i++) {
        if (groupHeight(groups[i]) + groupHeight(groups[i + 1]) <= maxHeight) {
          groups[i] = groups[i].concat(groups[i + 1]);
          groups.splice(i + 1, 1);
          changed = true;
          break;
        }
      }
    }

    container.innerHTML = '';
    groups.forEach(function(g) {
      var wrapper = document.createElement('div');
      wrapper.className = 'mega-menu__column-group';
      g.forEach(function(c) { wrapper.appendChild(c); });
      container.appendChild(wrapper);
    });
    container.dataset.packed = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', packMegaMenuColumns);
} else {
  packMegaMenuColumns();
}
document.addEventListener('shopify:section:load', packMegaMenuColumns);
